import React, { useEffect } from "react";
import styles from "./BOMOne.module.css";
import logo from "../../../assets/images/coyote-logo.jpg";

const BOMOne = () => {
  return (
    <div className={styles.bomBody}>
      <div className={styles.bomContainer}>
        <div className={styles.bomHeader}>
          <div className="coyote-logo">
            <img
              className="coyote-logo-image h-auto w-25"
              src={logo}
              alt="coyote-logo"
            />
          </div>
          <div className={styles.bomReportTitle}>
            <h1>BILL OF MATERIALS (BOM)</h1>
            <p>
              BOM Number:{" "}
              <span style={{ fontWeight: "bold" }}>BOM-2025-478</span>
            </p>
          </div>
        </div>

        <div className={styles.bomMetadataBox}>
          <div className={styles.bomMetadataRow}>
            <div>
              <span className={styles.bomMetadataLabel}>Project/Job:</span>{" "}
              Downtown Office Retrofit (J-0051)
            </div>
            <div>
              <span className={styles.bomMetadataLabel}>
                Receiving Warehouse:
              </span>{" "}
              Main Distribution Center (WH-01)
            </div>
          </div>
          <div className={styles.bomMetadataRow}>
            <div>
              <span className={styles.bomMetadataLabel}>Prepared By:</span> Jane
              Doe
            </div>
            <div>
              <span className={styles.bomMetadataLabel}>Date Generated:</span>{" "}
              October 29, 2025
            </div>
          </div>
        </div>

        <div className={styles.bomSummaryGrid}>
          <div className={styles.bomSummaryCard}>
            <div className={styles.bomLabel}>Total Products</div>
            <div className={styles.bomValue}>24</div>
          </div>
          <div className={styles.bomSummaryCard}>
            <div className={styles.bomLabel}>Total units Required</div>
            <div className={styles.bomValue}>1,850 Units</div>
          </div>
          <div className={styles.bomSummaryCard}>
            <div className={styles.bomLabel}>Available units in stock</div>
            <div className={styles.bomValue}>1400 Units</div>
          </div>
          <div className={`${styles.bomSummaryCard} ${styles.bomOrder}`}>
            <div className={styles.bomLabel}>Total Units To Order</div>
            <div className={`${styles.bomValue} ${styles.bomStatusShortage}`}>
              350 Units
            </div>
          </div>
        </div>

        <h3 className={styles.bomDetailedHeading}>Detailed Requirements</h3>
        <div className={styles.bomTableWrapper}>
          <table className={styles.bomDataTable}>
            <thead>
              <tr>
                <th>Phase</th>
                <th>Product (Model/SKU)</th>
                <th>Unit of Measure</th>
                <th>Manufacturer</th>
                <th>Qty Required</th>
                <th>Qty In Stock</th>
                <th>Qty Allocated*</th>
                <th>Net Available</th>
                <th>QTY TO ORDER</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Rough-in</td>
                <td>12/2 Gauge Cable (CW-122)</td>
                <td>ft</td>
                <td>Belden</td>
                <td>500</td>
                <td>400</td>
                <td>0</td>
                <td className={styles.bomStatusAvailable}>400</td>
                <td className={styles.bomQtyOrder}>100</td>
                <td>BACKORDER</td>
              </tr>
              <tr>
                <td>Rough-in</td>
                <td>Outlet Box (OB-4X4)</td>
                <td>ft</td>
                <td>Hubbell</td>
                <td>80</td>
                <td>120</td>
                <td>10</td>
                <td className={styles.bomStatusAvailable}>110</td>
                <td className={styles.bomQtyOrder}>0</td>
                <td>allied(Aisle 3 / R-A), south(Aisle 4 / Z-A)</td>
              </tr>
              <tr>
                <td>Finishing</td>
                <td>LED Panel Light (LED-600)</td>
                <td>cm</td>
                <td>Cree</td>
                <td>25</td>
                <td>30</td>
                <td>0</td>
                <td className={styles.bomStatusAvailable}>30</td>
                <td className={styles.bomQtyOrder}>0</td>
                <td>allied(Aisle 4 / R-D)</td>
              </tr>
              <tr>
                <td>Fit-out</td>
                <td>IP Security Camera (CAM-200)</td>
                <td>cm</td>
                <td>Axis</td>
                <td>5</td>
                <td>1</td>
                <td>0</td>
                <td className={styles.bomStatusShortage}>1</td>
                <td className={styles.bomQtyOrder}>4</td>
                <td>BACKORDER</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className={styles.bomFooter}>
          <p>
            *Qty Allocated: Quantity reserved by other active Bill of Materials.
            Stock status is based on real-time inventory at the time of report
            generation and is subject to change.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BOMOne;
